import styled from 'styled-components';

const AuthorName = styled.span`
  font-weight: 500;
`;

AuthorName.displayName = 'AuthorName';

export default AuthorName;
